import React from "react";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import FormLabel from "@mui/material/FormLabel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../../../../actions/actions";
import dayjs from "dayjs";
import { isSameDay } from "date-fns";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";
import { ALERT_SCREENS } from "../../../../global/constants";

const FinishTimeEntryHeaderBox = (props) => {
  const dispatch = useDispatch();
  const [eventId, seteventId] = React.useState(0);
  const [today, setToday] = React.useState(dayjs(new Date()));
  const [sessionsDate, setSessionsDate] = React.useState(dayjs(new Date()));
  const [disableFields, setDisableFields] = React.useState(false);
  const [raceSessionId, setRaceSessionId] = React.useState("");
  const penalties = useSelector(
    (state) => state.allPenalties.allPenalties.data
  );
  const initialEvent = useSelector((state) => state.eventData.eventData.data);
  const [event, setEvent] = React.useState(initialEvent);

  const initialEventList = useSelector(
    (state) => state.eventList.eventList.data
  );
  const raceSessions = useSelector(
    (state) => state.raceSessionData.raceSessionData.data
  );
  const initialRaceDates = useSelector(
    (state) => state.raceSeriesData.raceSeriesData.data
  );

  const club = useSelector((state) => state.clubData.clubData.data);

  const [highlightedDays, setHighlitedDays] = React.useState([]);

  const queryParameters = new URLSearchParams(window.location.search);
  const eventIdQ = queryParameters.get("id");
  const raceSessionIdQ = queryParameters.get("raceSessionId");
  const dateValQ = queryParameters.get("dateVal");
  const queryParams = [eventIdQ, raceSessionIdQ, dateValQ];
  const paramExist = queryParams.every(
    (value) => value !== null && value !== undefined
  );

  const retainDate = useSelector(
    (state) => state.selectedDate.selectedDate.data
  );

  React.useEffect(() => {
    if (initialEventList && initialEventList?.length > 0 && eventIdQ) {
      let selectedEvent = initialEventList.find((x) => x.eventId == eventIdQ);
      seteventId(eventIdQ);
      setEvent(selectedEvent);
      props.setEventId(eventIdQ);

      if (selectedEvent) {
        console.log("Selected Event Type:", initialEvent?.type);
        props?.setCaseOTBEntrant(selectedEvent?.type == 2 ? true : false);
      }
      let sessionDT = dayjs(dateValQ).format("YYYY-MM-DD");
      setSessionsDate(sessionDT);
      setToday(dayjs(sessionDT));
      props.setDate(sessionDT);
    }
  }, [initialEventList, eventIdQ, dateValQ]);

  React.useEffect(() => {
    if (initialEvent && initialEvent?.eventId && !eventIdQ) {
      seteventId(initialEvent?.eventId);
      setEvent(initialEvent);
      props.setEventId(initialEvent);

      if (initialEvent) {
        console.log("Selected Event Type:", initialEvent?.type);
        props?.setCaseOTBEntrant(initialEvent?.type == 2 ? true : false);
      }
      dispatch(actions.selectedEventData(initialEvent));
      dispatch(actions.fetchRaceDaysSeries(initialEvent?.eventId));
    }
  }, [initialEvent, eventIdQ]);

  React.useEffect(() => {
    if (
      initialEventList?.length > 0 &&
      !eventIdQ &&
      (!initialEvent?.eventId ||
        !initialEventList.some((e) => e.eventId === initialEvent?.eventId))
    ) {
      seteventId(initialEventList[0]?.eventId);
      setEvent(initialEventList[0]);
      props.setEventId(initialEventList[0] || { eventId: "" });
      dispatch(actions.selectedEventData(initialEventList[0]));
      dispatch(actions.fetchRaceDaysSeries(initialEventList[0]?.eventId));
    }
  }, [initialEvent, initialEventList, eventIdQ]);

  React.useEffect(() => {
    if (retainDate && retainDate?.date !== null) {
      setToday(dayjs(retainDate));
      setSessionsDate(dayjs(retainDate).format("YYYY-MM-DD"));
      props.setDate(dayjs(retainDate).format("YYYY-MM-DD"));
    } else {
      setToday(dayjs(new Date()));
    }
  }, [retainDate]);

  React.useEffect(() => {
    if (raceSessions && raceSessions.length > 0 && raceSessionIdQ) {
      let raceSessionObj = raceSessions.filter((rc) => {
        return rc.raceSessionId == raceSessionIdQ;
      })[0];
      let isOverNightRace = raceSessionObj.raceSessionsDetailList
        .map((ev) => {
          return ev.options.o === "Y";
        })
        .includes(true);
      props.setIsPlace(false);
      if (raceSessionObj != null) {
        if (raceSessionObj.raceSessionsDetailList.length > 0) {
          if (
            raceSessionObj.raceSessionsDetailList[0].series.resultOptions
              .length > 0 &&
            (raceSessionObj.raceSessionsDetailList[0].series.resultOptions[0]
              .resultBy[0] == "Place" ||
              raceSessionObj.raceSessionsDetailList[0].series.resultOptions[0]
                .resultBy[0] == "Custom-Place")
          ) {
            props.setIsPlace(true);
          }
        }
      }

      dispatch(actions.emptyRaceNotes(raceSessionObj.raceSessionId));
      props.setRaceSessions(raceSessionObj.raceSessionId, isOverNightRace);
      props.setRaceSessionNotes(
        raceSessionObj ? raceSessionObj.sessionNotes : ""
      );
      setRaceSessionId(raceSessionIdQ);
    }
  }, [raceSessions?.length, raceSessionIdQ]);

  React.useEffect(() => {
    if (initialRaceDates.length > 0) {
      setHighlitedDays(initialRaceDates.map((x) => x.raceDate.split("T")[0]));
    } else {
      setHighlitedDays([]);
    }
  }, [initialRaceDates]);

  const CustomDay = (props: PickersDayProps<Date>) => {
    const matchedStyles = highlightedDays.reduce((a, v) => {
      const date = new Date(props.day);
      return isSameDay(date, v) ? { backgroundColor: "#90EE90" } : a;
    }, {});

    return <PickersDay {...props} sx={{ ...matchedStyles }} />;
  };

  React.useEffect(() => {
    if (club?.type) {
      dispatch(actions.fetchEventList(0, club?.type));
    }
    dispatch(actions.fetchAllPenalties());
    sessionStorage.setItem("screen", ALERT_SCREENS.finishTimes);
  }, [club?.type]);

  React.useEffect(() => {
    // console.log("The penalties", penalties);
    props.setPenalties(penalties);
  }, [penalties]);

  React.useEffect(() => {
    if (eventId > 0) {
      dispatch(actions.fetchRaceDaysSeries(eventId));
    }
    if (eventId > 0 && sessionsDate) {
      let sessionDT = dayjs(sessionsDate).format("YYYY-MM-DD");
      setDisableFields(true);
      dispatch(actions.fetchRaceSession(eventId, sessionDT)).finally(() => {
        setDisableFields(false);
        setRaceSessionId(0);
      });
    }
  }, [eventId, sessionsDate]);

  const handleRaceSessionUpdate = (e) => {
    console.log("the sessions all", raceSessions);

    let raceSessionObj = raceSessions.filter((rc) => {
      return rc.raceSessionId === e.target.value;
    })[0];
    console.log("the raceSessionObj", raceSessionObj);
    let isOverNightRace = raceSessionObj.raceSessionsDetailList
      .map((ev) => {
        return ev.options.o === "Y";
      })
      .includes(true);
    props.setIsPlace(false);
    if (raceSessionObj != null) {
      if (raceSessionObj.raceSessionsDetailList.length > 0) {
        if (
          raceSessionObj.raceSessionsDetailList[0].series.resultOptions.length >
            0 &&
          (raceSessionObj.raceSessionsDetailList[0].series.resultOptions[0]
            .resultBy[0] == "Place" ||
            raceSessionObj.raceSessionsDetailList[0].series.resultOptions[0]
              .resultBy[0] == "Custom-Place")
        ) {
          props.setIsPlace(true);
        }
      }
    }

    dispatch(actions.emptyRaceNotes(raceSessionObj.raceSessionId));
    props.setRaceSessions(raceSessionObj.raceSessionId, isOverNightRace);
    props.setRaceSessionNotes(
      raceSessionObj ? raceSessionObj.sessionNotes : ""
    );
    setRaceSessionId(e.target.value);
  };

  const handleEventUpdate = (e) => {
    const selectedEvent = initialEventList.find(
      (ev) => ev.eventId === e.target.value
    );

    if (selectedEvent) {
      console.log("Selected Event Type:", selectedEvent.type);
      props?.setCaseOTBEntrant(selectedEvent?.type == 2 ? true : false);
    }
    seteventId(e.target.value);
    setEvent(initialEventList.find((x) => x.eventId == e.target.value));
    props.setEventId(initialEventList.find((x) => x.eventId == e.target.value));
    dispatch(
      actions.selectedEventData(
        initialEventList.find((x) => x.eventId == e.target.value)
      )
    );
    props.setRaceSessions("");
  };

  const formatDateValue = (value) => {
    let stringDay = "";
    let stringMonth = "";
    let year = String(value.$y);
    let day = parseInt(value.$D);
    let month = parseInt(value.$M) + 1;
    if (day < 10) {
      stringDay = "0" + String(day);
    } else {
      stringDay = String(day);
    }
    if (month < 10) {
      stringMonth = "0" + String(month);
    } else {
      stringMonth = String(month);
    }
    return year + "-" + stringMonth + "-" + stringDay;
  };
  const handleDateUpdate = (value) => {
    let sessionDT = dayjs(value).format("YYYY-MM-DD");
    setSessionsDate(sessionDT);
    props.setDate(sessionDT);
    dispatch(actions.selectedDate(sessionDT));
    props.setRaceSessions("");
    setRaceSessionId("");
  };
  return (
    <Box
      className="ty_header_box"
      sx={{
        marginBottom: "0.5rem",
      }}
    >
      <Grid
        container
        spacing={3}
        sx={{
          alignItems: "center",
          paddingRight: {
            xl: "12%",
            lg: "12%",
            md: "12%",
            sm: "0%",
            xs: "0%",
          },
        }}
      >
        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
          <Box>
            <FormLabel
              className="ty-uppercase-label"
              sx={{
                display: "block",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              Event <span className="label_red_star">*</span>
            </FormLabel>
            <Select
              sx={{ minWidth: "80px" }}
              size="small"
              displayEmpty
              // defaultValue={""}
              inputProps={{ "aria-label": "Without label" }}
              onChange={handleEventUpdate}
              disabled={paramExist || disableFields}
              value={event?.eventId || initialEventList[0]?.eventId || ""}
            >
              {initialEventList.map((event, index) => {
                return (
                  <MenuItem key={event.eventId} value={event.eventId}>
                    {event.eventName}
                  </MenuItem>
                );
              })}
            </Select>
          </Box>
        </Grid>
        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
          <Box>
            <FormLabel
              className="ty-uppercase-label"
              sx={{
                display: "block",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              Race Date <span className="label_red_star">*</span>
            </FormLabel>
            <Box className="datePickerField">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  format="YYYY-MM-DD"
                  defaultValue={dayjs()}
                  slots={{
                    openPickerIcon: CalendarTodayOutlinedIcon,
                    day: CustomDay,
                  }}
                  slotProps={{
                    openPickerButton: { color: "" },
                  }}
                  onChange={handleDateUpdate}
                  value={today}
                  disabled={paramExist || disableFields}
                  desktopModeMediaQuery="@media (min-width: 0px)"
                />
              </LocalizationProvider>
            </Box>
          </Box>
        </Grid>
        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
          <Box>
            <FormLabel
              className="ty-uppercase-label"
              sx={{
                display: "block",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              Race Session <span className="label_red_star">*</span>
            </FormLabel>
            <Select
              sx={{ minWidth: "80px" }}
              size="small"
              displayEmpty
              value={raceSessionIdQ || raceSessionId}
              inputProps={{ "aria-label": "Without label" }}
              onChange={handleRaceSessionUpdate}
              disabled={paramExist || disableFields}
            >
              {raceSessions != undefined &&
                raceSessions.map((raceSession, index) => (
                  <MenuItem
                    key={raceSession.raceSessionId}
                    value={raceSession.raceSessionId}
                  >
                    {raceSession.sessionName}
                  </MenuItem>
                ))}
            </Select>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FinishTimeEntryHeaderBox;
